import React, { useEffect } from "react";
import { MDBRow, MDBCol, MDBIcon, MDBBtn } from "mdb-react-ui-kit";
import { capitalizeFirstLettersOfString } from "../../../utils/stringOperations";

const LegislatorHeader = ({ legislator }) => {
  const title =
    legislator.legislatorDetails.chamber === "HOUSE"
      ? "Representative"
      : legislator.legislatorDetails.chamber === "SENATE"
      ? "Senator"
      : "";

  const status = legislator.legislatorProfile.isActive ? "" : "(Former)";

  return (
    <div id="profile" className="text-center">
      <div className="portrait mb-3">
        <img
          src={legislator?.legislatorProfile?.photo?.sizes?.lowres || 'potrait-not-found.png'}
          alt={`${legislator.legislatorDetails.firstName} ${legislator.legislatorDetails.lastName}`}
        />
      </div>
      <h6 className="lead mb-0">{`${title} ${status}`}</h6>
      <h2 className="mb-0">
        {legislator.legislatorDetails.firstName}{" "}
        {legislator.legislatorDetails.lastName}
      </h2>
      <h5>{legislator.legislatorDetails.position}</h5>
      {legislator.legislatorProfile.emailAddress && (
        <a
          href={`mailto:${legislator.legislatorProfile.emailAddress}`}
          className="btn btn-primary"
        >
          Contact Me
        </a>
      )}
    </div>
  );
};

export default LegislatorHeader;
